module.exports = __webpack_public_path__ + "img/bg_login_1.36827318.png";